"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISALLOWED_USER_AGENTS = void 0;
exports.allowedUserAgent = allowedUserAgent;
exports.DISALLOWED_USER_AGENTS = ['Datadog/Synthetics'];
function allowedUserAgent(userAgent) {
    if (!userAgent) {
        return true;
    }
    return !exports.DISALLOWED_USER_AGENTS.includes(userAgent);
}
